import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  listImage: {
    maxWidth: '100%'
  }
})

export default useStyles
